import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { StatusBadge, money } from "@/components/status";

export default function AdminJobs() {
  const [jobs, setJobs] = useState([]);
  const navigate = useNavigate();
  useEffect(() => { api.get("/admin/jobs").then((r) => setJobs(r.data)); }, []);
  return (
    <div className="space-y-6" data-testid="admin-jobs">
      <div>
        <h1 className="font-heading font-black text-3xl tracking-tight text-sapphire">All Jobs</h1>
        <p className="text-muted-foreground text-sm mt-1">Every job across the platform.</p>
      </div>
      <div className="border border-border rounded-md bg-white divide-y divide-border">
        {jobs.map((j) => (
          <button key={j.id} onClick={() => navigate(`/jobs/${j.id}`)} className="w-full flex items-center justify-between px-5 py-4 hover:bg-slate-50 text-left transition-colors" data-testid={`admin-job-${j.id}`}>
            <div>
              <div className="font-semibold text-sapphire">{j.property?.name}</div>
              <div className="text-sm text-muted-foreground">{j.pm?.name} → {j.cleaner?.name || "Unassigned"} · {j.date}</div>
            </div>
            <div className="flex items-center gap-3">
              <span className="font-heading font-bold text-sapphire">{money(j.payout_amount)}</span>
              <StatusBadge status={j.status} />
            </div>
          </button>
        ))}
        {jobs.length === 0 && <div className="p-8 text-center text-sm text-muted-foreground">No jobs.</div>}
      </div>
    </div>
  );
}
